import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as companyActions from '../../../actions/companyActions';
import * as userActions from '../../../actions/userActions';
import CompaniesList from './CompaniesList';
import CompanyCategoryRestrictionModal from './CompanyCategoryRestrictionModal';
import CompaniesListDivs from './CompaniesListDivs';
import MediaQuery from 'react-responsive';
import * as settingsActions from '../../../actions/settingsActions';
import BaseList from "../../common/list/BaseList";
import CustomPagination from '../../common/CustomPagination';
import SearchBarContainer from '../../common/searchbar/SearchBarContainer';
import {toastr} from "react-redux-toastr";
import CustomModal from './../../../components/CustomModal';
import * as modalActions from "../../../actions/common/modalActions";
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';
import CompaniesListHeading from "./CompaniesListHeading";
import CompanyPortalSelect from "./CompanyPortalSelect";
import CompanySubscriptionSelect from "./CompanySubscriptionSelect";
import * as sortableListActions from '../../../actions/common/sortableListActions';
import Resource from "../../../services/PrivateAPIResource";
import {toastrErrorHandler} from "./../../../actions/utils";
import WithResolvedPromises from "../../common/WithResolvedPromises";
import PlaceholderError from "../../common/PlaceholderError";
import PlaceholderTable from "../../common/PlaceholderTable";
import * as analyticOptions from "../../analytics/analyticOptions";


class CompaniesListContainer extends BaseList {
    constructor(props) {
        super(props);

        this.idToDelete = null;
        this.state = {
            page: 1,
            showDeleteModal: false,
            portalId: '',
            subscriptionType: '',
            actions: this.getRequiredActions()

        };

        this.listId = 'companies';
        this.onDelete = this.onDelete.bind(this);
        this.loginAs = this.loginAs.bind(this);
        this.onRestore = this.onRestore.bind(this);
        this.onPortalSelect = this.onPortalSelect.bind(this);
        this.onSubscriptionSelect = this.onSubscriptionSelect.bind(this);
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }

    getRequiredActions() {
        return [
            this.props.actions.getSetting('COMPANY_CATEGORY_LIMITERS'),
            this.props.actions.loadUsers(1),
            this.props.actions.loadCompanies('*'),
            this.props.actions.loadCompanyPortals()
        ]
    }

    componentWillUnmount() {
        this.props.actions.resetList(this.listId);
    }

    onPageChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.loadCompanies(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page});
    }

    onRestore(id) {
        this.props.actions.restoreCompany(id);
    }

    onDelete(id) {
        this.idToDelete = id;
        this.setState({showDeleteModal: true});
    }

    loginAs(company) {
        // cache the statistics filter dates (in cookies), but change the company
        let cachedFilter = analyticOptions.getCachedFilter();

        if (cachedFilter) {
            cachedFilter.companyId = company.id;
            analyticOptions.cacheFilterValues(cachedFilter, ['startDate', 'endDate', 'groupBy', 'type', 'companyId']);
        }

        Resource.create(`global-users/login-as-company/${company.id}`, new FormData(), true)
            .then(data => {
                this.props.actions.getCurrentUser();
                this.props.actions.getDemoAdminUser();
                this.context.router.history.push('/');
            })
            .catch(toastrErrorHandler);
    }

    hideDeleteModal() {
        this.idToDelete = null;
        this.setState({showDeleteModal: false});
    }

    confirmDelete() {
        if(this.idToDelete !== null) {

            this.props.actions.deleteCompany(this.idToDelete).then(() => {
                this.idToDelete = null;
                this.setState({showDeleteModal: false});
                this.props.actions.loadCompanies(this.state.page, this.getSortParams(this.props));
                toastr.success(this.props.intl.formatMessage(messages.companyDeleted));
            }).catch(() => {
                toastr.error(this.props.intl.formatMessage(messages.companyDeleteError));
            });

        } else {
            toastr.error(this.props.intl.formatMessage(messages.companyDeleteError));
            this.props.actions.hideModal();
        }
    }

    onPortalSelect(portalId) {
        this.setState({portalId, page: 1});

        let searchText = '';
        let withDeleted = true;
        let subscriptionType = '';

        if(this.props.sortableList[this.listId]) {
            searchText = this.props.sortableList[this.listId].search || '';
            withDeleted = !!this.props.sortableList[this.listId].withDeleted;
            subscriptionType = this.props.sortableList[this.listId].subscriptionType || '';
        }

        this.props.actions.updateList(
            this.listId,
            companyActions.loadCompanies,
            'id',
            'ASC',
            [1],
            searchText,
            withDeleted,
            portalId,
            subscriptionType
        );
    }

    onSubscriptionSelect(subscriptionType) {
        this.setState({subscriptionType, page: 1});

        let searchText = '';
        let withDeleted = true;
        let portalId = '';

        if(this.props.sortableList[this.listId]) {
            searchText = this.props.sortableList[this.listId].search || '';
            withDeleted = !!this.props.sortableList[this.listId].withDeleted;
            portalId = this.props.sortableList[this.listId].portalId || '';
        }

        this.props.actions.updateList(
            this.listId,
            companyActions.loadCompanies,
            'id',
            'ASC',
            [1],
            searchText,
            withDeleted,
            portalId,
            subscriptionType
        );
    }

    render() {
        let companies       = this.props.companies.data || [];
        let adminCompanyId  = (this.props.user.company) ? this.props.user.company.id : null;

        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable}  errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return (
                            <div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.companyDeleteModalTitle)}
                                    modalContent={<p>{this.props.intl.formatMessage(messages.companyDeleteQuestion)}</p>}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={() => {this.confirmDelete()}}
                                    handleHideModal={() => {this.hideDeleteModal()}}
                                    isOpen={this.state.showDeleteModal}
                                />
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-block">
                                                <MediaQuery maxWidth={415}>
                                                    <CompaniesListHeading listId={this.listId} mobile={true}/>
                                                </MediaQuery>
                                                <MediaQuery minWidth={415} maxWidth={1333}>
                                                    <CompaniesListHeading listId={this.listId} mobile={false} tablet={true}/>
                                                </MediaQuery>
                                                <MediaQuery minWidth={1334}>
                                                    <CompaniesListHeading listId={this.listId} mobile={false} tablet={false}/>
                                                </MediaQuery>
                                                <div className="row">
                                                    <div className="col-3">
                                                        <CompanyPortalSelect
                                                            portals={this.props.portals}
                                                            onPortalSelect={this.onPortalSelect}
                                                            sortableList={this.props.sortableList[this.listId] || []}
                                                        />
                                                    </div>
                                                    <div className="col-3">
                                                        <CompanySubscriptionSelect
                                                            onSubscriptionSelect={this.onSubscriptionSelect}
                                                            sortableList={this.props.sortableList[this.listId] || []}
                                                        />
                                                    </div>
                                                    <div className="col-5 offset-1">
                                                        <SearchBarContainer listId={this.listId} loadDataAction={companyActions.loadCompanies} />
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <CompaniesListDivs
                                                        companies={companies}
                                                        showCategoriesRestrictionModal={this.props.actions.showCompanyCategoryRestrictionModal}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <CompaniesList
                                                        listId={this.listId}
                                                        companies={companies}
                                                        showCategoriesRestrictionModal={this.props.actions.showCompanyCategoryRestrictionModal}
                                                        onDelete={this.onDelete}
                                                        loginAs={this.loginAs}
                                                        onRestore={this.onRestore}
                                                        adminCompanyId={adminCompanyId}
                                                        actionParams={[this.state.page] }
                                                        showPortals={!!this.state.portalId}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={this.props.companies.total}
                                        page={this.state.page}
                                        onPageChange={this.onPageChange.bind(this, addActions)}
                                    />
                                </div>
                                <CompanyCategoryRestrictionModal
                                    changeCategories={this.changeCategories}
                                />
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>
        );
    }
}

CompaniesListContainer.contextTypes = {
    router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        companies: state.companies,
        user: state.user,
        sortableList: state.sortableList,
        showDeleteModal: state.showDeleteModal,
        portals: state.companyPortals.filter(portal => portal.company_count),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                companyActions,
                userActions,
                settingsActions,
                modalActions,
                sortableListActions
            ), dispatch
        )
    }

}


export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(CompaniesListContainer));


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompaniesListContainer.jsx